import React, {useState, useRef} from "react";

import {values, clone} from "lodash";
import moment from "moment";
import {InputPicker, DatePicker, Input, Radio, RadioGroup, Toggle, Button} from "rsuite";

import {chronicConditionData} from "./util";
import {tooltip} from "components/Tooltips/ResidentTooltips";
import {WhisperWrapper} from "components/Tooltips/WhisperWrapper";

const PatientForm = ({
                         availableLocations,
                         disabledField,
                         availableSections,
                         availableRooms,
                         availableBeds,
                         patient,
                         facility,
                         section,
                         room,
                         bed,
                         requiredFieldClasses,
                         onChange,
                         onChangeInputPicker,
                         onClearLocation,
                         onValidateRequired,
                         onValidateCombo
                     }) => {

    const [isPhotoSelected, setIsPhotoSelected] = useState(false);
    const [photo, setPhoto] = useState({});
    const photoFileInput = useRef(null);

    const handleChangeData = (name, value) => {
        const date = moment(value);
        onChange(name, date);
    }

    const validateDate = (value) => {
        let date = moment(value);
        onValidateRequired("dob", date);
    }
    const clearPhotoInput = () => {
        setIsPhotoSelected(false);
        setPhoto({});
        onChange("photo", null);
        onChange("photoUrl", null);
    }

    const handleFileSelect = (e) => {
        const file = photoFileInput.current.files[0];

        if (file && (file.size > 5e6 || !["image/jpeg", "image/png", "application/pdf"].includes(file.type))) {
            alert("Please select a .jpg, .png. .pdf file smaller than 5MB.");
            clearPhotoInput();
        } else {
            const reader = new FileReader();

            reader.onload = (event) => {
                const photo = {
                    mimetype: file.type,
                    filename: file.name,
                    data: event.target.result.replace(/^.*,/, ""),
                };
                setIsPhotoSelected(true);
                setPhoto(photo);
                onChange("photo", photo);
            };

            reader.readAsDataURL(file);
        }
    }

    const hasInvalidFields = values(requiredFieldClasses).join().includes("invalid");
    const fieldClasses = clone(requiredFieldClasses);

    const availableLocationsData = availableLocations.map(item => ({label: item.name, value: item.name}));

    return (
        <div className="form">
            {hasInvalidFields &&
                <div className="alert alert-danger">
                    Highlighted fields are invalid
                </div>
            }
            <div className="row">
                <div className="col-md-8 br">
                    <div className="row">
                        <div className={` col-md-6  demographics-group ${fieldClasses.photo || ""}`}>
                            <label htmlFor="photo">Resident Photo</label>
                            {(isPhotoSelected || patient.photoUrl) ? (
                                <div className="photo-preview">
                                    {patient.photoUrl ? (
                                        <img alt="resident" src={patient.photoUrl}/>
                                    ) : (
                                        <img alt="resident" src={`data:${photo.mimetype};base64,${photo.data}`}/>
                                    )}
                                    <Button color="cyan" className="btn btn-info"
                                            onClick={clearPhotoInput}>Remove</Button>
                                </div>
                            ) : (
                                <div className="custom-file">
                                    <input type="file" className="custom-file-input" id="photo" ref={photoFileInput}
                                           onChange={handleFileSelect}/>
                                    <label className="custom-file-label settings-group" htmlFor="photo">Choose
                                        File...</label>
                                </div>
                            )}
                        </div>

                        <div className={`col-md-6 demographics-group ${fieldClasses.dob || ""}`}>
                            <label>Date of Birth2</label>
                            <DatePicker
                                className={`settings-group ${fieldClasses.dob || ""}`}
                                limitEndYear={0}
                                format="yyyy-MM-dd"
                                defaultValue={new Date(patient.dob)}
                                ranges={[]}
                                placeholder={"____.__.__"}
                                onChange={(value) => handleChangeData("dob", value)}
                                onClean={({target}) => onValidateRequired("dob", target.value)}
                                onOk={validateDate}

                            />
                        </div>

                        <div className={`col-md-6  demographics-group ${fieldClasses.firstName || ""}`}>
                            <label htmlFor="firstName">First Name</label>
                            <Input
                                className="settings-group"
                                onChange={(value) => onChange("firstName", value)}
                                onBlur={({target}) => onValidateRequired("firstName", target.value)}
                                value={patient.firstName}/>
                        </div>

                        <div className={`col-md-6  demographics-group ${fieldClasses.gender || ""}`}>
                            <label>Gender</label>
                            <RadioGroup name="gender" className="settings-group" inline value={patient.gender || ""}
                                        onChange={(value) => onChange("gender", value)}>
                                <Radio value="M"> Male</Radio>
                                <Radio value="F">Female</Radio>
                            </RadioGroup>
                        </div>

                        <div className={`col-md-6  demographics-group`}>
                            <label htmlFor="middleName">Middle Name</label>
                            <Input className="settings-group"
                                   onChange={(value) => onChange("middleName", value)}
                                   value={patient.middleName}/>
                        </div>

                        <div className={`col-md-6  demographics-group`}>
                            <label>Chronic Condition</label>
                            <InputPicker
                                data={chronicConditionData}
                                className="settings-group"
                                placeholder={"Select condition"}
                                onChange={(value) => onChange("condition", value)}
                                value={patient.condition}/>
                        </div>
                        <div className={`col-md-6  demographics-group ${fieldClasses.lastName || ""}`}>
                            <label htmlFor="lastName">Last Name</label>
                            <Input className="settings-group"
                                   onChange={(value) => onChange("lastName", value)}
                                   onBlur={({target}) => onValidateRequired("lastName", target.value)}
                                   value={patient.lastName}/>
                        </div>

                        <div className={`col-md-6  demographics-group ${fieldClasses.atRisk || ""}`}>
                            <div className="risk">
                                Resident at Risk
                                <Toggle className="settings-group" checked={patient.atRisk || false}
                                        onChange={(value) => onChange("atRisk", value)}/>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-4">
                    <div className={`demographics-group ${fieldClasses.room || ""}`}>
                        <span>
                            <label>Location</label>
                             <WhisperWrapper
                                 tooltip={tooltip}
                                 props={{placement: "bottom", controlId: "control-id-hover", trigger: "hover"}}
                             >
                                <Button size="xs" onClick={onClearLocation} className='btn-danger float-right'>Remove</Button>
                             </WhisperWrapper>
                        </span>
                        <InputPicker
                            className="settings-group"
                            data={availableLocationsData}
                            placeholder={"Select location"}
                            onChange={(value) => onChangeInputPicker("location", value)}
                            value={facility}/>
                    </div>
                    <div className={`demographics-group ${fieldClasses.room || ""}`}>
                        <label>Section</label>
                        <InputPicker
                            className="settings-group"
                            data={availableSections}
                            placeholder={"Select section"}
                            onChange={(value) => onChangeInputPicker("section", value)}
                            disabled={disabledField.section}
                            value={section}/>
                    </div>
                    <div className={`demographics-group ${fieldClasses.room || ""}`}>
                        <label>Room</label>
                        <InputPicker
                            className="settings-group"
                            data={availableRooms}
                            placeholder={"Select room"}
                            disabled={disabledField.room}
                            onChange={(value) => onChangeInputPicker("room", value)}
                            value={room}/>

                    </div>
                    <div className={`demographics-group ${fieldClasses.room || ""}`}>
                        <label>Bed</label>
                        <InputPicker
                            className="settings-group"
                            data={availableBeds}
                            placeholder={"Select bed"}
                            onChange={(value) => onChangeInputPicker("bed", value)}
                            disabled={disabledField.bed}
                            value={bed}/>
                    </div>
                </div>

            </div>
        </div>
    );
}

PatientForm.defaultProps = {
    availableLocations: null,
    disabledField: {
        section: true,
        room: true,
        bed: true,
    },
    availableSections: null,
    availableRooms: null,
    availableBeds: null,
    patient: null,
    facility: null,
    section: null,
    room: null,
    bed: null,
    requiredFieldClasses: {
        firstName: "required",
        lastName: "required",
        gender: "required",
        dob: "required",
    },
}

export default PatientForm;
